import { useState } from "react";
import { CheckCircle2, ChevronDown, HeartPulse } from "@/lib/icons";

export function WellbeingSection({ checkedInToday, children }) {
  const [open, setOpen] = useState(!checkedInToday);
  const show = open || !checkedInToday;
  return (
    <section data-testid="wellbeing-section">
      {checkedInToday && (
        <button onClick={() => setOpen((v) => !v)} data-testid="wellbeing-collapsed-toggle"
          className="w-full flex items-center gap-3 rounded-2xl bg-emerald-50 border border-emerald-200 px-4 py-3 text-left">
          <CheckCircle2 className="w-5 h-5 text-emerald-700 shrink-0" />
          <div className="flex-1"><div className="font-display font-bold text-emerald-900">Wellbeing check-in done for today ✓</div><div className="text-xs text-emerald-800/80">Tap to log again or add a note.</div></div>
          <ChevronDown className={`w-4 h-4 text-emerald-700 transition-transform ${show ? "rotate-180" : ""}`} />
        </button>
      )}
      {!checkedInToday && (
        <div className="flex items-center justify-between gap-2 mb-2">
          <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-stone-500"><HeartPulse className="w-3.5 h-3.5 text-rose-600" /> First, a quick check-in with yourself</div>
          <a href="#habits-column" data-testid="skip-to-habits" onClick={(e) => { e.preventDefault(); document.querySelector('[data-testid="habits-column"]')?.scrollIntoView({ behavior: "smooth" }); }} className="text-xs font-semibold text-amber-800 hover:text-amber-900">Skip to habits ↓</a>
        </div>
      )}
      {show && <div className={checkedInToday ? "mt-3" : ""}>{children}</div>}
    </section>
  );
}
